import React, { useState, useEffect } from 'react';
import './Pages.css';
import sollaiSol from '../assets/sollaiSol.png';

function OurApps() {
  const apps = [
    {
      id: 1,
      name: 'Sollai Sol',
      image: sollaiSol,
      description: 'The ultimate bilingual party game in Tamil and English! Race against time as you describe cards to your team while they guess as fast as they can. Perfect for bringing families and friends together across generations with laughter, quick thinking, and unforgettable moments.',
      playStoreUrl: 'https://play.google.com/store/apps/details?id=com.ulagatamizhar.sollai_sol',
      appStoreUrl: 'https://apps.apple.com/app/sollai-sol/id6756616907',
      playStoreAvailable: true,
      appStoreAvailable: true,  // Set to false to show "Coming Soon"
    },
    // Add more apps here as needed
  ];

  useEffect (() => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        console.log('Ad showing...');
      } catch (e) {
        console.error('Adsense error:', e);
      }
    }, []);

  return (
    <div className="page-container">
      <div className="apps-list">
        {apps.map((app) => (
          <div key={app.id} className="app-card">
            <div className="app-image">
              <img src={app.image} alt={app.name} />
            </div>
            
            <div className="app-content">
              <div className="app-info">
                <h3>{app.name}</h3>
                <p className="app-description">{app.description}</p>
              </div>
              
              <div className="store-buttons">
                {/* App Store Button */}
                {app.appStoreAvailable ? (
                  <a 
                    href={app.appStoreUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="store-btn"
                  >
                    <img 
                      src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1487808000" 
                      alt="Download on the App Store"
                      style={{height: '55px', width: '165px', objectFit: 'contain'}}
                    />
                  </a>
                ) : (
                  <div className="store-btn-wrapper">
                    <div className="store-btn store-btn-disabled">
                      <img 
                        src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1487808000" 
                        alt="Coming Soon on App Store"
                        style={{height: '55px', width: '165px', objectFit: 'contain'}}
                      />
                    </div>
                    <span className="coming-soon-badge">Coming Soon</span>
                  </div>
                )}

                {/* Google Play Button */}
                {app.playStoreAvailable ? (
                  <a 
                    href={app.playStoreUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="store-btn"
                    style={{overflow: 'hidden', height: '55px', width: '165px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px'}}
                  >
                    <img 
                      src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                      alt="Get it on Google Play"
                      style={{height: '80px', width: '165px', objectFit: 'cover'}}
                    />
                  </a>
                ) : (
                  <div className="store-btn-wrapper">
                    <div 
                      className="store-btn store-btn-disabled"
                      style={{overflow: 'hidden', height: '55px', width: '165px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px'}}
                    >
                      <img 
                        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                        alt="Coming Soon on Google Play"
                        style={{height: '80px', width: '165px', objectFit: 'cover'}}
                      />
                    </div>
                    <span className="coming-soon-badge">Coming Soon</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default OurApps;
